export const NavigationPath = {
	ALL: '*',
	landing: '/',
	login: '/login',
	applicationOnboarding: '/application-onboarding',
	applicationReview: '/application-review',
	dashboard: '/dashboard',
	coachAppointments: '/coach/appointments',
	coachRecurringCalendar: '/coach/appointments/recurring-calendar',
	coachInstantMeetings: '/coach/instant-meetings',
	coachMeetCompleted: '/coach/meet-completed',
	coachStudents: '/coach/students',
	coachStudentDetails: '/coach/students/detail',
	coachPastMeetings: '/coach/past-meetings',
	coachPastMeetingsDetail: '/coach/past-meetings/detail',
	gotItInstantMeetings: '/got-it/instant-meetings',
	gotItPastMeetings: '/got-it/past-meetings',
	gotItMeetCompleted: '/got-it/meet-completed',
	gotItPastMeetingsDetail: '/got-it/past-meetings/detail',
	gotItAppointments: '/got-it/appointments',
	gotItRecurringCalendar: '/got-it/appointments/recurring-calendar',
	gotItStudents: '/got-it/students',
	gotItStudentDetails: '/got-it/students/detail',
	gotItPlannedPastMeetings: '/got-it/planned-past-meetings',
	gotItPlannedAppointments: '/got-it/planned-appointments',
	gotItPlannedRecurringCalendar: '/got-it/planned-appointments/recurring-calendar',
	solverExpertReview: '/solver/expert-review',
	solverResolveQuestions: '/solver/resolve-questions',
	solverSolve: '/solver/solve',
	solverSolvedQuestions: '/solver/solved-questions',
	solverPastMeetingsDetail: '/solver/past-meetings/detail',
	solverWhiteBoard: '/solver/white-board',
	profile: '/profile',
	createAccount: '/create-account',
	meetConnectionTest: '/meet-connection-test',
	meetProviderTest: '/meet-provider-test',
	messages: '/messages',
	notifications: '/notifications',
	landingPage: '/landing',
	deleteAccount: '/delete-account',
	supportDocuments: '/support-documents',
	boutiqueClassroom: '/boutique-classroom',
	boutiqueStudents: '/boutique-classroom/students'
} as const;

export const WithSidebarNavigationPath = {
	[NavigationPath.coachAppointments]: true
};
export const WithLandingHeader = {
	[NavigationPath.login]: true,
	[NavigationPath.createAccount]: true
};

export const HideLeftMenuPaths = {
	[NavigationPath.profile]: true,
	[NavigationPath.messages]: true,
	[NavigationPath.notifications]: true
} as const;
